import HttpClient from "./HttpClient";

export default class Vehicle {
  constructor(vehicle) {
      if(!vehicle) return;
      this.id = vehicle.id;
      this.make = vehicle.make;
      this.number_plate = vehicle.number_plate;
      this.trailer_number_plate = vehicle.trailer_number_plate;
      this.driver = vehicle.driver;
      this.company_id = vehicle.company_id;
      this.created_at = vehicle.created_at;
      this.updated_at = vehicle.updated_at;
  }

  toString(){
    if(!this.id) return "";
    return this.trailer_number_plate;
  }

  static async loadVehicles(data) {
    const client = new HttpClient();
    const response = await client.instance.get("vehicles", data);
    const vehicles = [];
    response.data.data.forEach(vehicle => {
        vehicles.push(new Vehicle(vehicle));
    });
    return {
      vehicles: vehicles,
      page: response.data.current_page,
      pagesCount: response.data.last_page
    };
  }

  static async create(data){
    const client = new HttpClient();
    const response = await client.instance.post("vehicles", data);
    return response.data;
  }

  async save(){
    const client = new HttpClient();
    const response = await client.instance.put(`vehicles/${this.id}`, this);
    return response.data;
  }

  async delete(){
    const client = new HttpClient();
    const response = await client.instance.delete(`vehicles/${this.id}`);
    return response.data;
  }
}
